import { formatNumber } from "helpers/system";
import React from "react";

export default function RouteDetails({ route }) {
    if (!route) {
        return null;
    }

    return (
        <div>
            <div className="pb-3">
                <table className="table table-sm table-striped">
                    <thead>
                        <tr>
                            <th>Начало сегмента маршрута</th>
                            <th>Конец сегмента маршрута</th>
                            <th>Используемые шаблоны</th>
                        </tr>
                    </thead>
                    <tbody>
                        {route.segments.map((segment) => (
                            <tr key={segment.id}>
                                <td>{segment.mapObjectFrom.address}</td>
                                <td>{segment.mapObjectTo.address}</td>
                                <td>{(segment.patternIds || []).join(", ")}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {!!route.tollRoadSegments?.length && (
                <table className="table table-sm table-striped">
                    <thead>
                        <tr>
                            <th>Трасса</th>
                            <th>Пункт ПВП</th>
                            <th className="text-right">Пн - Чт</th>
                            <th className="text-right">Пт - Вск</th>
                        </tr>
                    </thead>
                    <tbody>
                        {route.tollRoadSegments.map((item) => {
                            if (!item.rules) {
                                return null;
                            }
                            return item.rules.map((rule, i) => (
                                <tr key={`${item.id}_${i}`}>
                                    <td>{item.trackName}</td>
                                    <td>{rule.name}</td>
                                    <td className="text-right">
                                        {formatNumber(rule.cost, { style: "currency", currency: "RUB" })}
                                    </td>
                                    <td className="text-right">
                                        {formatNumber(rule.weekendCost, { style: "currency", currency: "RUB" })}
                                    </td>
                                </tr>
                            ));
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
}
